var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1437_3263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333C13.6667 18.3333 13.3333 18 13.3333 17.5V15.8333C13.3333 14.4166 12.25 13.3333 10.8333 13.3333H4.16667C2.75 13.3333 1.66667 14.4166 1.66667 15.8333V17.5C1.66667 18 1.33333 18.3333 0.833333 18.3333C0.333333 18.3333 0 18 0 17.5V15.8333C0 13.5 1.83333 11.6666 4.16667 11.6666H10.8333C13.1667 11.6666 15 13.5 15 15.8333V17.5C15 18 14.6667 18.3333 14.1667 18.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50004 10C5.16671 10 3.33337 8.16669 3.33337 5.83335C3.33337 3.50002 5.16671 1.66669 7.50004 1.66669C9.83337 1.66669 11.6667 3.50002 11.6667 5.83335C11.6667 8.16669 9.83337 10 7.50004 10ZM7.50004 3.33335C6.08337 3.33335 5.00004 4.41669 5.00004 5.83335C5.00004 7.25002 6.08337 8.33335 7.50004 8.33335C8.91671 8.33335 10 7.25002 10 5.83335C10 4.41669 8.91671 3.33335 7.50004 3.33335Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 18.3334C18.6666 18.3334 18.3333 18 18.3333 17.5V15.8334C18.3333 14.6667 17.5833 13.6667 16.5 13.4167C16.0833 13.3334 15.75 12.8334 15.9166 12.4167C16 12 16.5 11.6667 16.9166 11.8334C18.75 12.3334 20 14 20.0833 15.8334V17.5C20 18 19.6666 18.3334 19.1666 18.3334Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.91665C13 9.91665 12.5833 9.66665 12.5 9.24999C12.4166 8.83332 12.6666 8.33332 13.0833 8.24999C14 7.99999 14.6666 7.33332 14.9166 6.41665C15.25 5.08332 14.4166 3.74999 13.0833 3.33332C12.6666 3.33332 12.4166 2.83332 12.5 2.41665C12.5833 1.99999 13.0833 1.66665 13.5 1.83332C15.75 2.41665 17.0833 4.66665 16.5 6.91665C16.0833 8.41665 15 9.58332 13.5 9.91665C13.5 9.91665 13.4166 9.91665 13.3333 9.91665Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1437_3263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingEvents);
export default __webpack_public_path__ + "static/media/upcoming-events.36a66412f1d75058adedd2928c32762f.svg";
export { ForwardRef as ReactComponent };